<template>
    <div class="main-wrappers top-bar" style="background-color: white;">
      <div v-if="isLoading" class="p-3">
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </div>
      <div v-else-if="script">
        <div style="padding: 24px;">
           <a :href="!appType?'/marketplace-apps-review?t=customjs':`/marketplace-apps-review?t=customjs&type=${appType}`" style="display: flex; justify-content: start; color: black;"><u><i class="fa fa-thin fa-arrow-left"></i>{{ " Back to Dashboard" }}</u></a>
            <div style="display: flex;padding-top: 1rem; padding-bottom: 1rem;" > 
                <div style="justify-items: start; display: flex;width: 77%; ">
                    <div style="width: 92%; padding-left: 0.5rem;">
                        <div style="display: inline;justify-items: start;width: 100%;">
                            <div style="display:flex;gap: 0.5rem;">
                                <div class="heading-font truncate">{{ script.name }}</div>
                                <div class="position-center">
                                    <div class="tag info subtitle-font" style="padding: 0.25rem; padding-inline: 0.5rem;display: flex;"> <i class="fa fa-sharp fa-clock"/><span style="padding-left: 0.25rem;">{{ formatVersion(script.version) }}</span> </div>
                                </div>
                                <div v-if="script.isExternalScriptAllowed" class="position-center">
                                    <div class="tag warning subtitle-font" style="padding: 0.25rem; padding-inline: 0.5rem;display: flex;"><span style="padding-left: 0.25rem;">Allow External Scripts</span> </div>
                                </div>
                                <div class="position-center">
                                    <div class="tag success subtitle-font" style="padding: 0.25rem; padding-inline: 0.5rem;display: flex;"><span style="padding-left: 0.25rem;">{{ script.target??'agency_dom' }}</span> </div>
                                </div>
                            </div>
                            <div class="subtitle-font" style="display: flex;justify-items: start; "> <div class="truncate">{{ script.description }} </div></div>
                            <div v-if="script.status==='inReview'" style="display: flex;justify-items: start; gap:0.5rem;padding-top: 0.5rem;">
                                <button id="approve-script" class="btn btn-primary" @click="reviewApp(false)" size="sm">Approve</button>
                                <button id="disapprove-script" class="btn danger-btn" @click="reviewApp(true)" size="sm">Disapprove</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="width: 23%;">
                    <div style="width: 100%;">
                      <div style="display: flex; justify-content: start; gap: 0.225rem;">
                          <div v-if="script.status" :class="script.status==='approved'? 'tag success toCapitalFirst':(script.status==='disapproved'?'tag danger toCapitalFirst':'tag warning toCapitalFirst' )"><span class="mx-1">{{ script.status }}</span></div>                
                        </div>
                        <div style="gap:0.25rem;display: flex; justify-items: start;"><span>Submitted on:</span><b>{{ formatTime(script.submittedOn) }}</b></div>
                        <div style="gap:0.25rem;display: flex; justify-items: start;"><span>Approved on:</span><b>{{ formatTime(script.reviewedOn) }}</b></div>
                        <div style="gap:0.25rem;display: flex; justify-items: start;"><span>SLA:</span><b>{{ script.sla ? script.sla : "-" }}</b></div>
                    </div>
                </div>

            </div>
        </div>
        <b-tabs >            
            <b-tab title="Custom JS" active>
            <Overview :data="script"/>
            </b-tab>            
            <b-tab title="Activity log">
            <ActivityLog :appId="script.oAuthClientId" :itemId="scriptId" itemType="customJs"/>
            </b-tab>            
        </b-tabs>
        <modal v-if="showModal" :max-width="600">
            <div class="modal-box">
                <div>
                    <div class="modal-header" style="border-bottom:0px;padding: 0px;background-color: white">
                        <div v-if="modalType==='Approve'" style="border-radius: 50%; width: 35px; height: 35px;background-color: #ECFDF3;display: flex;justify-content: center;align-items: center;">
                            <div style="border-radius: 50%; width: 25px; height: 25px;background-color: #D1FADF;">
                                <i class="fa fa-check" style="color: #039855"></i>
                            </div>
                        </div>
                        <div v-else style="border-radius: 50%; width: 35px; height: 35px;background-color:#FFFAEB;display: flex;justify-content: center;align-items: center;">
                            <div style="border-radius: 50%; width: 25px; height: 25px;background-color: #FEF0C7">
                                <i class="fa fa-info" style="color:#FDB022"></i>
                            </div>
                        </div>
                        <i class="fa fa-times modal-close-icon" @click="confirmationModal(false)" />                    
                    </div>
                    <div class="text-left pb-4" style="padding-top:1rem;">
                        <div v-if="modalType==='Approve'" >
                            <h5><b>Are you sure you want to Approve this script?</b></h5>
                            <div class="sub-text">On approving, the script, customers can access the same via the App installation.</div>
                        </div>
                        <div v-else>
                            <h5><b>Are you sure you want to Disapprove this script?</b></h5>
                            <div class="sub-text">Please share your feedback with the developer on changes required to approve the Script.</div>                        
                        </div>
                    </div>
                </div>
                <div id="modal-body" class="text-left">
                    <textarea id="comment-section" type="textarea" placeholder="Add comment" rows="4" v-model="comment" required class="hl_input--wrap my-1"/> 
                    <div v-if="modalType==='Approve'">
                        <input id="sendMail" type="checkbox" class="mr-2" v-model="shareViaMail" />                        
                        <label for="send" class="sub-text">Share comments with the App developer via email</label>
                    </div>
                    <div v-else class="sub-text">
                        On disapproving, an email will be sent to the App developer with the comments.
                    </div>
                </div>
                <div id="modal-footer" style="width:100%;display: flex; gap:0.5rem;" class="pt-4">
                    <button class="btn" @click="confirmationModal(false)" style="width: 50%;" :disabled="isSaving">Cancel</button>
                    <button v-if="modalType==='Approve'" class="btn btn-primary" @click="submit(false)" style="width: 50%;" :disabled="isSaving">Approve</button>
                    <button v-else class="btn btn-danger" @click="submit(true)" style="width: 50%;" :disabled="isSaving">Disapprove</button>
                </div>
            </div>
        </modal>
      </div>
      <div v-else class="p-3">
        <router-link :to="!appType?'/marketplace-apps-review?t=customjs':`/marketplace-apps-review?t=customjs&type=${appType}`" style="display: flex; justify-content: start; color: black;"><u><i class="fa fa-thin fa-arrow-left"></i>{{ " Back to Dashboard" }}</u></router-link>        
        <div class="heading-font">Script not found</div>
      </div>
    </div>
</template>
  
<script>
import * as moment from "moment";
import Modal from "@/components/common/Modal.vue";
import { MarketplaceService } from "@/services"
import Overview from "./Overview"
import ActivityLog from "@/components/marketplace/marketplaceAppsReviewPortal/ActivityLog"
import { ReviewStatus } from "@/constants/Oauth.ts"
require('../style.css')

export default {
    components:{Overview, ActivityLog, Modal},
    data() {
      return {
        scriptId: this.$route.params.customScriptId,
        script: undefined,
        showModal:false,
        modalType:undefined,
        comment:undefined,
        shareViaMail:false,
        isSaving:false,
        isLoading:false,
        appType:'Pending Review'
      }
    },
    async created() {
      await this.fetchData()
    },
    methods: {
      async fetchData(){
        try {
          this.isLoading = true;
          let query = {
              skip: 0,
              limit: 1
          }
          if(this.$route.query.type){
            query['status'] = this.$route.query.type
          }
          if(this.scriptId){
            query['itemId'] = this.scriptId
          }
          const response = await MarketplaceService.Review.getScriptsForReview(query)
          this.script = response.data.scripts[0] || {}        
        } catch(error){
          console.error(error);
          alert(error.message || error.message[0] || "Something went wrong");
        }finally{
          this.isLoading = false
        }
      },
      async submit(isRejected) {
        try {
          if(!this.comment){            
            alert("Comment is mandatory");
            return
          }
          this.isSaving = true;
          const currentUser = this.$store.state?.auth?.user         
          const data = {
            approvalStatus: isRejected ? "disapproved" : "approved",
            approvedBy: currentUser.email,
            isShareEnabled: isRejected ? true : this.shareViaMail,
            comment: this.comment           
          }          
          const response = await MarketplaceService.Review.createScriptReview(this.scriptId, data)
          if(response.data && response.data.success){
            this.appType = isRejected ? "Disapproved" : "Approved"
            alert(response.data.message || "Success");
            this.$router.push({name:"marketplace-apps-review", query:{             
              t:'customjs'
            }})
          }          
          this.confirmationModal(false)
        } catch(error){
          console.error(error);
          alert(error.message || error.message[0] || "Something went wrong");
          this.confirmationModal(false)
        }finally{
            this.isSaving = false            
        }
      },
      formatTime(time){
        return moment(time).format(
          "MMM DD, YYYY"
        )
      },
      formatVersion(version){
        return parseFloat(version || 1).toFixed(1)
      },
      reviewApp(isRejected){
        this.modalType = isRejected ? "Disapprove": "Approve"
        this.shareViaMail = isRejected ? true : false
        this.confirmationModal(true)
      },
      confirmationModal(value){
        this.showModal=value
      } 
    }
  };
</script>
